export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";